export default "__VITE_ASSET__BAeB3lZP__"